import datapoints from './datapoints';
import deleteMailListRowsHelper from './helpers/deleteMailListRowsHelper';
import deleteConversationService from '../services/deleteConversationService';
import restoreConversationService from '../services/restoreConversationService';
import composeStore from 'owa-mail-compose-store/lib/store/composeStore';
import getUniqueConversationContextsForRowKey from './helpers/getUniqueConversationContextsForRowKey';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import { actionNames } from 'owa-mail-store-actions';
import * as undoActions from 'owa-mail-undo';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import strings from 'owa-strings/owa-mail-strings';
import { action, select } from 'satcheljs/lib/legacy';
import { raiseAction } from 'satcheljs/lib/legacy/stitch';
import { getContextFolderIdForTable } from 'owa-mail-list-store';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import { userMailInteractionAction } from 'owa-mail-actions';
import showNotificationOnDeleteSucceeded from './helpers/showNotificationOnDeleteSucceeded';
import { MailboxType } from 'owa-client-ids';
import { isGroupTableQuery } from 'owa-group-common';
/**
 * The action worker which handles deleting the given conversations
 * @param conversationActionContexts - action contexts
 * @param conversationIds - the conversation that need to be deleted
 * @param originalTableView - the table view the conversation should be deleted from
 * @param disposalType - the disposal type
 * @param actionSource - the action source
 */
export var deleteConversationsWithoutConfirmDialog = action('deleteConversationsWithoutConfirmDialog', datapoints.deleteConversationDatapoint)(function deleteConversationsWithoutConfirmDialog(conversationActionContexts, originalTableViewId, disposalType, instrumentationContexts, actionSource) {
    var conversationIds = conversationActionContexts.map(function (conversationContext) { return conversationContext.conversationId; });
    var originalTableView = listViewStore.tableViews.get(originalTableViewId);
    // raise stitch to delete conversation from list view and reading pane
    raiseAction(actionNames.DeleteConversationStoreUpdate)(conversationIds, originalTableView);
    undoActions.clearLastUndoableAction();
    var mailboxInfo = getMailboxInfo(originalTableView);
    var options = mailboxInfo.requestOptions;
    var isUserMailbox = mailboxInfo.type === MailboxType.UserMailbox;
    var contextFolderId = getContextFolderIdForTable(originalTableView);
    // Make service request
    deleteConversationService(conversationActionContexts, contextFolderId, disposalType, options).then(function (response) {
        // After action completes successfully, add it to the undo stack
        // Only enable undo functionality when delete action was successful, if
        // we are in a user mailbox and if delete was not a SoftDelete
        if (response.ResponseClass == 'Success' &&
            disposalType === 'MoveToDeletedItems' &&
            isUserMailbox) {
            var deletedItemsFolderId_1 = folderNameToId('deleteditems');
            undoActions.addActionToUndoStack(function () {
                return restoreConversationService(conversationActionContexts, deletedItemsFolderId_1);
            });
            showNotificationOnDeleteSucceeded(conversationActionContexts.length);
        }
    });
    userMailInteractionAction('Delete', instrumentationContexts);
});
/**
 * Initiates deleting of the given conversations
 * @param conversationRowKeys - the conversation that need to be deleted
 * @param originalTableViewId - the table view the conversation should be deleted from
 * @param isExplicitSoftDelete flag to indicate whether disposal type is soft delete
 * @param actionSource - the action source
 * @param state - some additional state required to complete the action
 */
export var deleteConversationsFromTable = select({
    originalTableView: function (conversationId, originalTableViewId) {
        return listViewStore.tableViews.get(originalTableViewId);
    },
})(function deleteConversationsFromTable(conversationRowKeys, originalTableViewId, isExplicitSoftDelete, instrumentationContexts, actionSource, state) {
    var isGroupMailbox = isGroupTableQuery(state.originalTableView.tableQuery);
    var confirmDialogStrings = {
        deleteNumberOfRowsTitle: strings.deleteNumberOfConversations,
        deleteOneRowTitle: strings.deleteItem,
        confirmDeleteRows: isGroupMailbox
            ? strings.confirmDeletingGroupConversation
            : strings.confirmDeletingConversation,
    };
    return deleteMailListRowsHelper(conversationRowKeys, originalTableViewId, isExplicitSoftDelete, function (rowKeys, disposalType) {
        var conversationActionContexts = getUniqueConversationContextsForRowKey(rowKeys, originalTableViewId);
        deleteConversationsWithoutConfirmDialog(conversationActionContexts, originalTableViewId, disposalType, instrumentationContexts, actionSource);
    }, isReplyingToOneOfConversations, confirmDialogStrings);
});
function isReplyingToOneOfConversations(conversationIds) {
    var replyConversationId = composeStore.defaultViewState && composeStore.defaultViewState.conversationId;
    return replyConversationId && conversationIds.indexOf(replyConversationId) >= 0;
}
//# sourceMappingURL=deleteConversations.js.map